import { queryOptions, useQuery } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebQueryKeys, neWebUrls } from "../../../../ne-web-urls";
import type { components } from "../../../../types/neWebApi.types";

type AiChatFeedbackRow = Required<
  components["schemas"]["AdminFeedbackMessageFeedbackResponseBody"]
>;

function aiChatAdminFeedbackQueryOptions(
  rating: string,
  days: number,
  limit: number
) {
  return queryOptions({
    queryKey: neWebQueryKeys.aiChat.adminFeedback(rating, days, limit),
    queryFn: () => fetchAiChatAdminFeedback(rating, days, limit)
  });
}

async function fetchAiChatAdminFeedback(
  rating: string,
  days: number,
  limit: number
) {
  const aiChatAdminFeedbackUrl = neWebUrls.api.aiChatAdminFeedback(
    rating,
    days,
    limit
  );
  const response = await neWebApi.get<Array<AiChatFeedbackRow>>(
    aiChatAdminFeedbackUrl
  );

  return response.data;
}

export function useAiChatFeedback(rating: string, days: number, limit: number) {
  return useQuery(aiChatAdminFeedbackQueryOptions(rating, days, limit));
}

export type { AiChatFeedbackRow };
